<mat-card appearance="outlined" class="se-block">
  <mat-card-header class="se-header" [class.se-read-only]="readOnly">
    <mat-card-title class="se-title">{{ 'CALIPER' | translate }}</mat-card-title>
    <button *ngFor="let customMeasureButton of customMeasureButtons" class="se-button" mat-button [disabled]="!selectedMeasures" (click)="onClick(customMeasureButton)">{{customMeasureButton.text}}</button>
  </mat-card-header>

  <table class="measure-table">
    <tr>
      <th scope="col" matTooltip="{{'DeleteAllMeasures' | translate }}" matTooltipClass="mat-tooltip-bigger">
        <img class="row-image" src="assets/images/remove.png" alt="Remove" (click)="onRemoveAll()" />
      </th>
      <th scope="col">Ld</th>
      <th scope="col">A1</th>
      <th scope="col">A2</th>
      <th scope="col">&Delta;A</th>
      <th scope="col">&Delta;T</th>
      <th scope="col">HR</th>
    </tr>
    <tr class="rows" *ngFor="let measures of measuresList" [class.rowactive]="measures.caliper.highlight" [class.rowselected]="measures.selected" [class.se-read-only]="readOnly" (click)="onSelect(measures)" (mouseover)="onMouseOver(measures)"
      (mouseout)="onMouseOut(measures)">
      <td>
        <img class="row-image" [class.remove]="!measures.caliper.highlight" src="assets/images/remove.png" alt="Remove"
          (click)="onRemove(measures)" (mouseover)="onMouseOver(measures)" (mouseout)="onMouseOut(measures)" />
      </td>
      <td>{{measures.caliper.title}}</td>
      <td>{{measures.measures?.A1 | number: '1.2-2' }}</td>
      <td>{{measures.measures?.A2 | number: '1.2-2' }}</td>
      <td>{{measures.measures?.deltaA | number: '1.2-2' }}</td>
      <td>{{measures.measures?.deltaT | number: '1.0-0' }}</td>
      <td>{{measures.measures?.HR | number: '1.0-0' }}</td>
    </tr>
  </table>
</mat-card>
